module.exports = __webpack_public_path__ + "static/media/back.5914774d.svg";